export enum FilterContainerStates {
  EXPANDED,
  COLLAPSED,
}
